import 'select2';
import '../sass/jobs/jobs.scss';
import { isEmptyValue, createCookie, eraseCookie, getUrlParameter, readCookie } from './helpers';

(function ($) {
    const $ireland_locations = [
        'cork',
        'ardmore',
        'dunmore',
        'munster',
        'ulster',
        'antrim',
        'belfast',
        'armagh',
        'lisburn',
        'clare',
        'bandon',
        'bantry',
        'fermoy',
        'kinsale',
        'mallow',
        'donegal',
        'bangor ',
        'newry ',
        'warrenpoint',
        'dublin ',
        'galway',
        'menlo',
        'kildare ',
        'kilkenny',
        'limerick',
        'coleraine',
        'derry',
        'londonderry ',
        'baltimore',
        'dundalk ',
        'mayo',
        'boyne valley',
        'tara',
        'monaghan',
        'roscommon',
        'sligo',
        'dunganno',
        'strabane',
        'tyrone',
        'waterford',
        'athlone',
        'duncannon',
        'enniscorthy',
        'wexford',
        'avoca',
        'rathdrum',
        'antrim',
        'armagh',
        'athlone',
        'avonmore',
        'bailieboro',
        'ballyhack',
        'baltimore',
        'brandon',
        'calabogie peaks',
        'caledon',
        'carlingford',
        'carlingford',
        'cashel',
        'castlereagh',
        'cavan-monaghan',
        'coleraine',
        'connaught',
        'donegal',
        'dundalk',
        'dublin',
        'enniskillen',
        'enniskillen',
        'erin estates',
        'innisfail',
        'innisfil',
        'innisfree',
        'keady',
        'kilbride',
        'kildare',
        'kildare',
        'kildare capes',
        'kilkenny',
        'killaloe',
        'killarney',
        'killarney',
        'kilrush',
        'kinsale',
        'leitrim',
        'limerick',
        'limerick lake',
        'limerick',
        'lismore',
        'listowel',
        'londonderry',
        'lougheed',
        'lougheed island',
        'lucan',
        'malahide',
        'maynooth',
        'meath park',
        'mount mellick',
        'mullingar',
        'navan',
        'new bandon parish',
        'new bandon-salmon beach',
        'new ross',
        'newry',
        "queen's county",
        'saint-ambroise-de-kildare',
        'sainte-marcelline-de-kildare',
        'shaughnessy',
        'shaughnessy village',
        'shaughnessy',
        'tramore',
        'tullamore',
        'tyrone',
        'new waterford',
        'waterford',
        'westmeath',
        'westmeath provincial park',
        'wicklow parish',
        'wicklow',
        'avoca',
        'ballina',
        'ballyroe',
        'belmore',
        'carlingford',
        'castlereagh',
        'castlereagh street',
        'cavan',
        'clontarf',
        'fingal bay',
        'fingal head',
        'killarney heights',
        'killarney vale',
        'limerick',
        'lismore',
        'londonderry',
        'louth',
        'point clare',
        'rathmines',
        'tallow beach',
        'tipperary',
        'tralee',
        'tullamore',
        'charleville',
        'clontarf',
        'derrymore',
        'glanmire',
        'innisfail',
        'killarney',
        'mount enniskillen',
        'rathdowney',
        'waterford',
        'armagh',
        'cavan',
        'clare',
        'clare valley',
        'dublin',
        'erindale',
        'glandore',
        'kilkenny',
        'fingal',
        'liffey',
        'longford',
        'ross',
        'shannon river',
        'athlone',
        'belfast lough',
        'cape clear',
        'castlemaine',
        'coleraine',
        'drumcondra',
        'killarney',
        'kilmore',
        'longford',
        'maryborough',
        'newry',
        'portarlington',
        'glendalough',
        'leinster',
        'londonderry',
        'munster',
        'waterford',
        'athlone',
        'bantry bay',
        'belfast',
        'cashel',
        'killarney',
        'kylemore',
        'ireland',
    ];
    var page_URL = window.location.search.substring(1);
    const form_job_search = $('#form-job-search'),
        default_search_cookie = 'default-search-cookie',
        default_jobtype_cookie = 'search-jobs-type',
        globals = {
            wp_admin_url: ajaxpagination.ajaxurl,
        };

    const isInStandaloneMode = () => {
        return (
            ('standalone' in window.navigator && window.navigator.standalone) ||
            window.matchMedia('(display-mode: standalone)').matches
        );
    };

    // Mobile filter toggle
    $('.filter-toggle-btn').on('click', function (e) {
        e.preventDefault();

        $(this).toggleClass('search_active');
        $('.search-job-section').toggleClass('filter-enabled');
        $('.form-filters').toggleClass('search_active');
        if ($(this).hasClass('search_active')) {
            $(this).attr('aria-expanded', 'true');
            if ($(window).innerWidth() > 767) {
                $('.filter-inputs .custom-select[name="business_area"]')
                    .parents('.form-group')
                    .find('textarea')
                    .trigger('focus');
            } else {
                $('#search_text').trigger('focus');
            }
        } else {
            $(this).attr('aria-expanded', 'false');
        }
    });

    $('.close-filter-btn').on('click', function () {
        $(this).removeClass('active');
        $('.search-job-section').removeClass('filter-enabled');
        $('.form-filters').removeClass('active');
    });

    $(document).on('change', '.sortby-box select', function () {
        $('#sort_by').val();
        $('#sort_by').val(this.value);
        $('.search-form-box input[name=offset]').val(0);
        loadJobs(false);
    });
    $(document).on('change', '.sortby-box .custom-select', function () {
        $('#sort_by').val();
        $('#sort_by').val(this.value);
        $('#form-job-search').trigger('submit');
        setTimeout(() => {
            $('.sortby-box .custom-select').attr('selected', '');
            $(this).val(this.value);
        }, 3000);
    });

    // Keyword suggestions
    $('.custom-select-searchable').each(function () {
        var $select = $(this);
        $select.select2({
            ajax: {
                url: globals.wp_admin_url,
                type: 'POST',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    if (params.term && params.term.length > 2) {
                        let $filterWrapper = $select.closest('.custom-filters');
                        let submitValue = $filterWrapper.find('input[name=submit]').val();
                        let jobfeedValue = $filterWrapper.find('input[name=jobfeed]').val();

                        return {
                            action: 'dm_do_autocomplete',
                            data: {
                                search_text: params.term,
                                submit: submitValue,
                                jobfeed: jobfeedValue,
                            },
                        };
                    } else {
                        return {};
                    }
                },
                beforeSend: function () {
                    $select.closest('.position-relative').find('.serch_loader').show();
                },
                complete: function () {
                    $select.closest('.position-relative').find('.serch_loader').hide();
                },
                processResults: function (data) {
                    return {
                        results: data,
                    };
                },
            },
            placeholder: 'Enter keywords',
            minimumInputLength: 3,
            dropdownParent: $select.closest('.searchable-select'),
            tags: true,
        });
    });

    // Log the search term whenever it changes
    $('.custom-select-searchable').on('select2:open', function () {
        let searchTerm = $(this).parents('.form-group').find('.select2-selection__rendered').text();
        if (searchTerm !== 'Enter keywords' && searchTerm !== '') {
            $(this).parents('.form-group').find('.select2-search__field').val(searchTerm);
            $(this).trigger('change.select2');
        }
    });

    function toggleClearSearchBtn() {
        let searchTerm = $('.select2-container--open').find('.select2-search__field').val();
        if (searchTerm !== 'Enter keywords' && searchTerm !== '') {
            $('.select2-container--open').parents('.form-group').find('.custom-clear-search').show();
        }
    }

    $(document).on('keyup', '.select2-container--open .select2-search__field', function () {
        let searchTerm = $(this).val();

        if (searchTerm !== 'Enter keywords' && searchTerm !== '') {
            $(this).parents('.form-group').find('.custom-clear-search').show();
        }
    });

    // Show the clear button only when there is a value selected
    $('.custom-select-searchable').on('change', function (e) {
        const selectedValue = $(this).val();
        if (selectedValue) {
            $('.searchable-select .custom-clear-search').show();
        } else {
            $('.searchable-select .custom-clear-search').hide();
        }
    });

    // clear keyword search
    $('.searchable-select .custom-clear-search').on('click', function (e) {
        e.preventDefault();
        $('.custom-select-searchable').val(null).trigger('change');
    });

    // hide suggestion ul

    let suggestionAjaxRequest = null;
    $(document).on('keyup', '#search_text, #job-alert-search_text', function (e) {
        e.preventDefault();

        const $currentInput = $(this);
        const inputId = $currentInput.attr('id');
        const $loader = inputId === 'search_text' ? $('.serch_loader') : $('.job_alert_keyword-loader');
        let $suggestedList = $currentInput.siblings('.suggested');

        // Do nothing if enter and arrow keys are pressed
        if ([13, 37, 39].indexOf(e.which) > -1) return;

        // Handle up and down arrow key navigation
        if (e.which === 38 || e.which === 40) {
            if ($suggestedList.length) {
                const $chooseItem = $suggestedList.find('.choose');
                const $suggestedItems = $suggestedList.find('li');
                let currentIndex = $suggestedItems.index($chooseItem);

                if (e.which === 38 && currentIndex > 0) {
                    // Up arrow key
                    $chooseItem.removeClass('choose');
                    $suggestedItems.eq(currentIndex - 1).addClass('choose');
                } else if (e.which === 40 && currentIndex < $suggestedItems.length - 1) {
                    // Down arrow key
                    $chooseItem.removeClass('choose');
                    $suggestedItems.eq(currentIndex + 1).addClass('choose');
                } else if (e.which === 40 && currentIndex === -1) {
                    // First item on down arrow key when none selected
                    $suggestedItems.eq(0).addClass('choose');
                }
            }
            return;
        }

        $suggestedList.find('.choose').removeClass('choose');
        // Fetch suggestions if input length is >= 3
        if ($currentInput.val().length >= 3) {
            const $data = $currentInput
                .closest('form')
                .serializeArray()
                .reduce(function (obj, item) {
                    obj[item.name] = item.value;
                    return obj;
                }, {});

            $data['jobfeed'] = $('input[name=jobfeed]').val();
            $data['submit'] = $('input[name=submit]').val();

            $loader.addClass('show');

            // Send AJAX request to fetch suggestions
            suggestionAjaxRequest = $.ajax({
                url: globals.wp_admin_url,
                type: 'POST',
                data: {
                    action: 'dm_do_autocomplete',
                    data: $data,
                },
                beforeSend: function () {
                    if (suggestionAjaxRequest != null) {
                        suggestionAjaxRequest.abort();
                    }
                },
                success: function (response) {
                    $loader.removeClass('show');

                    // Parse the response if it's a JSON string
                    if (typeof response === 'string') {
                        try {
                            response = JSON.parse(response);
                        } catch (e) {
                            console.error('Failed to parse response:', e);
                            response = [];
                        }
                    }

                    if (Array.isArray(response) && response.length > 0) {
                        let listItems = response
                            .map(function (item) {
                                return '<li><a href="#">' + item.text + '</a></li>';
                            })
                            .join('');

                        // Update or append suggestions list
                        if ($suggestedList.length) {
                            $suggestedList.html(listItems);
                            $suggestedList.show();
                        } else {
                            $suggestedList = $('<ul class="suggested">' + listItems + '</ul>').insertAfter(
                                $currentInput
                            );
                        }
                    } else {
                        // Hide suggestions list if response is empty
                        $suggestedList.hide();
                    }
                },
            });
        } else {
            if (suggestionAjaxRequest != null) {
                suggestionAjaxRequest.abort();
            }

            // Hide suggestions list if input length is less than 3
            $suggestedList.hide();
            $loader.removeClass('show');
        }
    });

    // Hide suggestions list when clicking outside
    $('body').on('mousedown', function (evt) {
        console.log(
            $(evt.target).closest('.suggested')?.[0],
            $('#search_text').siblings('.suggested')?.[0],
            $('#search_text').siblings('.suggested')?.[0]
        );
        if (
            !$(evt.target).is('#search_text, #job-alert-search_text') &&
            !$(evt.target).closest('.suggested')?.[0] == $('#search_text').siblings('.suggested')?.[0] &&
            !$(evt.target).closest('.suggested')?.[0] == $('#job-alert-search_text').siblings('.suggested')?.[0]
        ) {
            $('.suggested').hide();
        }

        if ($(evt.target).is('.link-job-description, .job-card-list .job-card .title a')) {
            checkJobsloadstate();
        }

        if ((evt.ctrlKey && evt.button === 0) || evt.button === 1 ) {
            checkJobsloadstate();
        }
    });

    // Handle suggestion click event
    $(document).on('click', '.suggested a', function (e) {
        e.preventDefault();

        const $clickedSuggestion = $(this);
        const suggestionText = $clickedSuggestion.text().trim();
        const $formGroup = $clickedSuggestion.closest('.form-group');
        const $inputField = $formGroup.find('input[type="text"]');

        $inputField.val(suggestionText);
        $formGroup.find('.suggested').hide();

        // if its job alert popup suggestion list after selection create/update chipset values
        if ($clickedSuggestion.closest('form').attr('id') === 'jobs_alerts_form') {
            populateInputValues();
            buildChipsFromInputValuesForJobAlert();
        }
    });

    $('.custom-select.multiple').trigger('change');
    window.addEventListener('offline', () => {
        $('.magnific-popup-trigger').magnificPopup('close');
    });
    function loadJobs(scrooll_to_results = true) {
        var address = $('input[name=location]').val();
    
        if (address !== '') {
            address += jQuery.inArray(address.toLowerCase(), $ireland_locations) >= 0 ? ', ireland' : '';
            $('#address').val(address);
            $('#address2').val(address);
        } else {
            $('#address').val('');
            $('#address2').val('');
        }
        var offset = $('input[name=offset]').val();
        
        var results_container = $('.resultscontainer');
        results_container.html('<div class="loader">Loading...</div>');
    
        var data = form_job_search.serializeArray().reduce((obj, item) => {
            obj[item.name] = obj[item.name] ? `${obj[item.name]},${item.value}` : item.value;
            return obj;
        }, {});
    
        var jobfeed = $('input[name=jobfeed]').val();
        let is_jobtype_selected = readCookie(default_jobtype_cookie);
        const search_text = data['search_text'] ? data['search_text'].trim() : '';
        const location = data['location'] ? data['location'].trim() : '';
        const business_area = data['business_area'] ? data['business_area'].trim() : '';

        if ((!is_jobtype_selected || is_jobtype_selected != jobfeed)) {
            createCookie(default_jobtype_cookie, jobfeed);
        }   
        
        $.ajax({
            url: globals.wp_admin_url,
            type: 'POST',
            data: {
                action: 'dm_do_search_ajax',
                offset: offset,
                data: data,
            },
            beforeSend: function () {
                $('.suggested').remove();
            },
            success: function (response) {
                results_container.html(response);

                if ((search_text || location || business_area || jobfeed) && $('.zero-results').length === 0) {
                    createCookie(
                        default_search_cookie,
                        JSON.stringify({ data, jobfeed })
                    );
                }

                const searched_location = results_container.find('#searched-location').val();
                if (searched_location) {
                    notificationManager.updateLocationTags(searched_location);
                }

                const businessAreaCookie = readCookie('business-area');
                let businessAreaName = null;

                if (businessAreaCookie) {
                    const businessArea = JSON.parse(businessAreaCookie);
                    businessAreaName = businessArea.name;
                }

                if (typeof businessAreaName === 'string' && businessAreaName.trim() !== '') {
                    notificationManager.sendTag('business_area', businessAreaName);
                }
                notificationManager.sendTag('jobfeed_type', readCookie('search-jobs-type'));

                if (scrooll_to_results) {
                    const offset = $(window).width() > 1279 ? 100 : $('nav.nav').outerHeight(true);
                    const top = $('.job-result-section').offset().top - offset;

                    $('html,body').animate(
                        { scrollTop: top },
                        500
                    );
                }

                if (isInStandaloneMode()) {
                    if (document.body.classList.contains('search-jobs')) {
                        const jobContainer = document.querySelector('.job-card-list');
                        if (jobContainer) {
                            const job_links = jobContainer.querySelectorAll('a[target="_blank"]');
                            job_links.forEach((link) => {
                                link.removeAttribute('target');
                            });
                        }
                    }
                }
            },
            complete: function () {
                if ($('.zero-results').length > 0) {
                    $('.sorting-wrap').hide();
                }

                $('.content-popup-trigger').magnificPopup({
                    type: 'inline',
                    closeBtnInside: true,
                    autoFocusLast: true,
                    fixedBgPos: true,
                    fixedContentPos: true,
                });
            },
        });
    }


    function buildSearchChips() {
        if (form_job_search.length === 0) return;

        $('.filtered-by-list ul').html('');
        $('.search_form_data').html('');

        let filterParams = {};

        $('#form-job-search :input').each(function () {
            if (!isEmptyValue(this.value) && $(this).attr('type') != 'hidden') {
                const inputValue = $(this).val(),
                    inputName = this.name;
                $('.subscribe_wrap').removeClass('hide');

                if (Object.prototype.toString.call(inputValue) == '[object Array]') {
                    $(inputValue).each(function (index, value) {
                        $('.filtered-by-list ul').append(`
                            <li>${value}<button data-bind="${inputName}" aria-label="remove item ${value} from ${inputName}" name="" chip-val="${value}"><span class="sr-only">Close</span></button></li>
                        `);

                        filterParams[inputName] = filterParams[inputName] || [];
                        filterParams[inputName].push(value);
                    });
                } else {
                    $('.filtered-by-list ul').append(`
                        <li>${inputValue}<button data-bind="${inputName}" aria-label="remove item ${inputName}" name=""><span class="sr-only">Close</span></button></li>
                    `);

                    filterParams[inputName] = inputValue;
                }
                $('.filtered-by-list').addClass('visible');
            }
        });

        if ($('.filtered-by-list ul').children('li').length === 0) {
            $('.filtered-by-list').removeClass('visible');
        }

        populateInputValues();
        buildChipsFromInputValuesForJobAlert();
        handleLocationChange('#jobs_alerts_form');

        updateURLWithFilters(filterParams);
    }

    function updateURLWithFilters(filters) {
        const urlParams = new URLSearchParams(window.location.search);
        const allowedParams = ['search_text', 'location', 'radius'];

        allowedParams.forEach(param => {
            if (!(param in filters)) {
                urlParams.delete(param);
            }
        });
        for (let [key, value] of Object.entries(filters)) {
            if (allowedParams.includes(key)) {
                if (Array.isArray(value)) {
                    urlParams.delete(key);
                    value.forEach(val => {
                        urlParams.append(key, val);
                    });
                } else {
                    urlParams.set(key, value);
                }
            }
        }
        const newURL = `${window.location.pathname}?${urlParams.toString()}`;
        if (window.location.search !== `?${urlParams.toString()}`) {
            history.replaceState({ path: newURL }, '', newURL);
        }
    }

    // Handle filter input modification in the popup form
    $('.job-alert-filters-wrapper .form-group :input').on('change', function (e) {
        e.preventDefault();
        populateInputValues();
        buildChipsFromInputValuesForJobAlert();
        disabledJobAlertFormSubmitButton();
    });

    // This for text inputs, on enter create chip and prevent form submission
    $('.job-alert-filters-wrapper .form-group input[type="text"]').on('keypress', function (e) {
        if (e.which === 13) {
            e.preventDefault();

            const $suggestedItem = $('.job-alert-filters-wrapper .suggested .choose');
            if ($suggestedItem.length) {
                const chosenText = $suggestedItem.find('a').text().trim();
                $(this).val(chosenText);
                $('.suggested').hide();
            }

            populateInputValues();
            buildChipsFromInputValuesForJobAlert();
            disabledJobAlertFormSubmitButton();
        }
    });

    // Define an object to store filter input values
    let inputValues = {};

    // Function to populate inputValues object with current input values
    function populateInputValues() {
        $('.job-alert-filters-wrapper .form-group :input').each(function () {
            const $this = $(this);
            const inputValue = $this.val();
            const inputName = $this.attr('name');
            // Store input values in the inputValues object
            inputValues[inputName] = inputValue;
        });
    }

    // Function to build chips based on inputValues object
    function buildChipsFromInputValuesForJobAlert() {
        const $filteredList = $('#jobs_alerts_form .job-alert-filtered-by-list ul');
        $filteredList.empty();

        // Iterate through inputValues object and build chips
        Object.entries(inputValues).forEach(([inputName, inputValue]) => {
            // Convert inputValue to array if it's not already an array
            if (!Array.isArray(inputValue)) {
                inputValue = [inputValue];
            }

            // Add chips for each value of the input
            inputValue?.forEach((value) => {
                if (typeof value === 'string') {
                    value = value.trim();
                    if (value) {
                        $filteredList.append(`
                            <li>${value}<button data-bind="${inputName}" aria-label="remove item ${value} from ${inputName}" chip-val="${value}" name=""><span class="sr-only">Close</span></button></li>
                        `);
                    }
                }
            });
        });

        // Add the "Edit Filter" button if it's not already present
        if (!$filteredList.find('.job-alert-edit-filter').length) {
            $filteredList.append(`
                <li class="job-alert-edit-filter"><button aria-label="Edit job alert filters" title="Click to expand job alert filters panel"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 117.74 122.88" style="enable-background:new 0 0 117.74 122.88" xml:space="preserve"><style type="text/css">.st0{fill-rule:evenodd;clip-rule:evenodd;}</style><g><path class="st0" d="M94.62,2c-1.46-1.36-3.14-2.09-5.02-1.99c-1.88,0-3.56,0.73-4.92,2.2L73.59,13.72l31.07,30.03l11.19-11.72 c1.36-1.36,1.88-3.14,1.88-5.02s-0.73-3.66-2.09-4.92L94.62,2L94.62,2L94.62,2z M41.44,109.58c-4.08,1.36-8.26,2.62-12.35,3.98 c-4.08,1.36-8.16,2.72-12.35,4.08c-9.73,3.14-15.07,4.92-16.22,5.23c-1.15,0.31-0.42-4.18,1.99-13.6l7.74-29.61l0.64-0.66 l30.56,30.56L41.44,109.58L41.44,109.58L41.44,109.58z M22.2,67.25l42.99-44.82l31.07,29.92L52.75,97.8L22.2,67.25L22.2,67.25z"/></g></svg>Edit filters</button></li>
            `);
        }
        const expanded = $('.job-alert-filters-wrapper').is(':visible');
        if (expanded) {
            $('.job-alert-edit-filter').hide();
        } else {
            $('.job-alert-edit-filter').show();
        }
    }

    let $select = $('#job-alert-radius');
    if(!$select.data('original-options')){
        $select.data('original-options', $select.children().clone());
    }

    // Job alert reset filter
    $('.job-alert-reset-filter').on('click', function (e) {
        e.preventDefault();
        $('.job-alert-add-filter').css('display', 'flex').trigger('focus');
        $('.job-alert-filters-wrapper').slideUp();
        $('#jobs_alerts_form select').trigger('change');
        $('#jobs_alerts_form .custom-select.multiple').val(null).trigger('change');
    
        $select.html($select.data('original-options').clone()).val(null);

        $('.job-alert-filters-wrapper :input')
            .not('.no-reset')
            .each(function () {
                $(this).val('');
            });
        $('#jobs_alerts_form .custom-select')
            .closest('.form-group')
            .find('.select2-search__field')
            .attr('placeholder', 'Select');
            
        $('.job-alert-filtered-by-list ul').empty();
        disabledJobAlertFormSubmitButton();
        handleLocationChange('#jobs_alerts_form');
    });

    function disabledJobAlertFormSubmitButton() {
        if ($('.job-alert-filtered-by-list ul').children('li:not(.job-alert-edit-filter)').length === 0) {
            $('.submit_wrap .submit-form').attr('disabled', 'disabled');
            $('.add-filter-error').addClass('show-error');
        } else {
            $('.submit_wrap .submit-form').removeAttr('disabled');
            $('.add-filter-error').removeClass('show-error');
        }
    }

    // Handle pagination
    $(document).on('click', '.pagination li a', function (e) {
        e.preventDefault();
        $('input[name=offset]').val(parseInt($(this).data('page')) - 1);
        loadJobs();
        checkJobsloadstate();
    });

    function checkJobsloadstate() {
        const timer = setInterval(() => {
            // Stop pace loader when the document is fully loaded
            if (document.readyState === 'complete') {
                Pace.stop(); // Stop Pace once readyState is complete
                clearInterval(timer); // Clear the timer
                updatePageLoadingState(false);
            }
        }, 500); // Run the check every 500ms
    }

    // Handle zero results button click - Displayed when no jobs match with filter criteria.
    $(document).on('click', '.zero-button', function (e) {
        e.preventDefault();
        $('.reset-form').trigger('click');
        loadJobs(false);
    });

    // Handle zero results suggestions click - Displayed when no jobs match with filter criteria.
    $(document).on('click', '.zero-results ul a', function (e) {
        e.preventDefault();
        $('#search_text').val($(this).text());
        loadJobs(false);
    });

    if (getParameterByName('jobfeed') == 'internal') {
        setTimeout(() => {
            $('[name=job-type-selector][value=internal]').click();
        }, 300);
    }

    // distance disabled on location based
    $('[name=location]').on('keyup change', function () {
        handleLocationChange('#form-job-search');
    });

    $('[name=job-alert-location]').on('keyup change', function () {
        handleLocationChange('#jobs_alerts_form');
    });

    // to track the location value is set by user typing and not by location button click
    $('[name=job-alert-location]').on('input', function () {
        emptyLatLonCountryValues('#jobs_alerts_form');
    });

    function handleLocationChange(element) {
        const $element = $(element);
        const $locationInput = $element.find('.validate_location');
        const $radiusInput = $element.find('.input-radius');

        if ($locationInput.val() === '') {
            $radiusInput.prop('disabled', true).val(null).trigger('change');
        } else {
            $radiusInput.prop('disabled', false);
        }
    }

    function emptyLatLonCountryValues(element) {
        const $element = $(element);
        $element.find('.location-dependency').val('');
    }

    function checksorting() {
        var address = $('input[name=location]').val();
        var search_text = $('input[name=search_text]').val();
        if (address !== '') {
            $('.sortby-box select option[value="distance"]').prop('disabled', false);
        } else {
            $('.sortby-box select option[value="distance"]').prop('disabled', true);
        }
        if (search_text !== '') {
            $('.sortby-box select option[value="score"]').prop('disabled', false);
        } else {
            $('.sortby-box select option[value="score"]').prop('disabled', true);
        }
        if (address !== '' && search_text !== '') {
            $('.sortby-box select option[value="distance"]').prop('selected', true);
        }
    }

    handleLocationChange('#form-job-search');

    // Form Data
    form_job_search.on('submit', function (e) {
        e.preventDefault();
        const searchInput = form_job_search.find('input[name=search_text]');

        // If the autocomplete suggestion is open and a suggestion is highlighted, set it as the search string.
        const $suggestedList = searchInput.siblings('.suggested');
        const $suggestedItem = $suggestedList.find('.choose');

        if ($suggestedItem.length) {
            const chosenText = $suggestedItem.find('a').text().trim();
            searchInput.val(chosenText);
        }

        form_job_search.find('[name="offset"]').val(0);
        $('.search-job-section').removeClass('show-filter-element');

        $('#jobs_alerts_form [name="job-alert-search_text"]').val(form_job_search.find('[name="search_text"]').val());
        $('#jobs_alerts_form [name="job-alert-location"]').val(form_job_search.find('[name="location"]').val());
        $('#jobs_alerts_form [name="job-alert-radius"]')
            .val(form_job_search.find('[name="radius"] :selected').val())
            .trigger('change');

        var seleted_jobstype = form_job_search.find('[name="fulltime_parttime"]').select2('val');
        var seleted_ctype = form_job_search.find('[name="contract_type"]').select2('val');
        var seleted_business = form_job_search.find('[name="business_area"]').select2('val');
        var seleted_function = form_job_search.find('[name="function_area"]').select2('val');
        var seleted_job_level = form_job_search.find('[name="job_level"]').select2('val');

        $('#jobs_alerts_form [name="job-alert-fulltime_parttime"]').val(seleted_jobstype).trigger('change');
        $('#jobs_alerts_form [name="job-alert-contract_type"]').val(seleted_ctype).trigger('change');
        $('#jobs_alerts_form [name="job-alert-business_area"]').val(seleted_business).trigger('change');
        $('#jobs_alerts_form [name="job-alert-function_area"]').val(seleted_function).trigger('change');
        $('#jobs_alerts_form [name="job-alert-job_level"]').val(seleted_job_level).trigger('change');

        $('#jobs_alerts_form [name="job-alert-lat"]').val(form_job_search.find('[name="lat"]').val());
        $('#jobs_alerts_form [name="job-alert-lon"]').val(form_job_search.find('[name="lon"]').val());
        $('#jobs_alerts_form [name="job-alert-country"]').val(form_job_search.find('[name="country"]').val());

        var formData = $(this)
            .find(':input')
            .map(function () {
                return {
                    name: $(this).attr('name'),
                    value: $(this).val(),
                };
            })
            .get();
        localStorage.setItem('formData', JSON.stringify(formData));

        const address = $('input[name=location]').val();
        const search_text = $('input[name=search_text]').val();
        $('.sortby-box select option[value="score"]').prop('disabled', true);
        $('.sortby-box select option[value="distance"]').prop('disabled', true);

        if (search_text !== '' || address !== '') {
            $('.sorting-wrap').show();
        }
        if (search_text !== '' && address !== '') {
            $('.sortby-box select option[value="distance"]').prop('selected', true);
            $('.sortby-box select option[value="distance"]').prop('disabled', false);
            $('.sortby-box select option[value="score"]').prop('disabled', false);
            $('#sort_by').val('distance');
            $('.sort-relative').addClass('show-sortby-filter');
        } else if (address !== '') {
            $('#sort_by').val('distance');
            $('.sortby-box select option[value="distance"]').prop('selected', true);
            $('.sortby-box select option[value="distance"]').prop('disabled', false);
            $('.sortby-box select option[value="score"]').prop('disabled', true);
            $('.sort-relative').addClass('show-sortby-filter');
        } else if (search_text !== '') {
            $('#sort_by').val('score');
            $('.sortby-box select option[value="distance"]').prop('disabled', true);
            $('.sortby-box select option[value="score"]').prop('disabled', false);
            $('.sortby-box select option[value="score"]').prop('selected', true);
            $('.sort-relative').addClass('show-sortby-filter');
        } else {
            $('#sort_by').val('date');
            $('.sortby-box select option[value="score"]').prop('disabled', true);
            $('.sortby-box select option[value="distance"]').prop('disabled', true);
            $('.sort-relative').removeClass('show-sortby-filter');
        }

        buildSearchChips();
        jQuery('body').removeClass('job-filters-open');
        loadJobs(false);

        return false;
    });

    // Handle filter chips remove event
    $(document).on('click', '.filtered-by-list button', function (e) {
        e.preventDefault();

        var chipVal = $(this).attr('chip-val');

        if ($(this).data('bind')) {
            var inputName = $('[name=' + $(this).data('bind') + ']');
            if (form_job_search.find(inputName).is('select')) {
                const newArray = $(inputName).val();
                if (Object.prototype.toString.call($(inputName).val()) == '[object Array]') {
                    $($(inputName).val()).each(function (index, value, array) {
                        if (value === chipVal) {
                            newArray.splice(index, 1);
                        }
                    });
                    $('.filtered-by-list').addClass('visible');
                    form_job_search.find(inputName).val(newArray).trigger('change');
                } else {
                    $(inputName).val(null).trigger('change');
                }
            } else {
                $(inputName).val(null).trigger('change');
            }
        }
        $('.sortby-box select option[value="distance"]').prop('disabled', true);
        $('.sortby-box select option[value="score"]').prop('disabled', true);
        $('.sortby-box select option[value="date"]').prop('selected', true);

        if (search_text == '' && address == '') {
            $('.sort-relative').removeClass('show-sortby-filter');
        }
        checksorting();

        form_job_search.trigger('submit');
        if ($('.filtered-by-list li').length === 0) {
            $('.filtered-by-list').removeClass('visible');
            $('.subscribe_wrap').addClass('hide');
        }
    });

    // Job alert popup handle filter chips remove event
    $(document).on(
        'click',
        '#jobs_alerts_form .job-alert-filtered-by-list li:not(.job-alert-edit-filter) button',
        function (e) {
            e.preventDefault();

            const chipVal = $(this).attr('chip-val');

            if ($(this).data('bind')) {
                const inputName = $('#jobs_alerts_form [name=' + $(this).data('bind') + ']');

                // Remove the parent <li> when the close button is clicked
                $(this).parent().remove();

                if ($('#jobs_alerts_form').find(inputName).is('select')) {
                    const newArray = $(inputName).val();
                    if (Object.prototype.toString.call($(inputName).val()) == '[object Array]') {
                        $($(inputName).val()).each(function (index, value, array) {
                            if (value === chipVal) {
                                newArray.splice(index, 1);
                            }
                        });
                        $('#jobs_alerts_form .job-alert-filtered-by-list').addClass('visible');
                        $('#jobs_alerts_form').find(inputName).val(newArray).trigger('change');
                    } else {
                        $(inputName).val(null).trigger('change');
                    }
                } else {
                    $(inputName).val(null).trigger('change');
                }

                if (inputName[0].name === 'job-alert-location') {
                    emptyLatLonCountryValues('#jobs_alerts_form');
                }
            }
            updateJobAlertFilterBtnVisibility();
        }
    );

    // Prevent the default form submission behavior for the input fields
    $(document).on('keydown', '#jobs_alerts_form .disable-enter', function (event) {
        if (event.key === 'Enter') {
            event.preventDefault();
        }
    });

    // On job alert button click
    $(document).on('click', '.subscribe_wrap .magnific-popup-trigger', function (e) {
        e.preventDefault();
        setTimeout(() => {
            updateJobAlertFilterBtnVisibility();
        }, 100);
    });

    function updateJobAlertFilterBtnVisibility() {
        const expanded = $('.job-alert-filters-wrapper').is(':visible');
        const filteredListLength = $('.job-alert-filtered-by-list ul').children(
            'li:not(.job-alert-edit-filter)'
        ).length;

        if (filteredListLength === 0 && !expanded) {
            $('.job-alert-add-filter').css('display', 'flex');
        } else {
            $('.job-alert-add-filter').css('display', 'none');
        }

        if (filteredListLength === 0) {
            $('.job-alert-edit-filter').hide();
        } else {
            $('.job-alert-edit-filter').show();
            if (expanded) {
                $('.job-alert-edit-filter').hide();
            }
        }
    }

    // Handle reset form
    $(document).on('click', '.reset-form', function (e) {
        e.preventDefault();
        $('.sort-relative').removeClass('show-sortby-filter');
        $('.filtered-by-list').removeClass('visible');
        form_job_search.trigger('reset');
        form_job_search.find('[name="offset"]').val(0);
        $('.subscribe_wrap').addClass('hide');
        $('#lat, #lon , #for_airport').val('');
        $('.reveal').removeClass('reveal');
        $('.filter-form-wrapper .form-group.location .custom-placeholder').removeClass('hide');
        $('.custom-select.multiple').val(null).trigger('change');

        $('#form-job-search :input')
            .not('.no-reset')
            .each(function () {
                $(this).val('');
            });
        $('.sortby-box select option[value="distance"]').prop('disabled', true);
        $('.sortby-box select option[value="score"]').prop('disabled', true);
        $('.sortby-box select option[value="date"]').prop('selected', true);
        jQuery('.custom-select')
            .closest('.form-group')
            .find('.select2-search__field')
            .each(function () {
                let placeholderText = $(this).closest('.form-group').find('.custom-select').attr('aria-label');
                $(this).attr('placeholder', placeholderText);
            });
        checksorting();
        loadJobs(false);
        handleLocationChange("#form-job-search");
    });

    function checkFiltersAndLoadJobs(elClassName) {
        form_job_search.find('[name="jobfeed"]').val($(elClassName).val());
        $('.filter-popup [name="jobfeed"]').val($(elClassName).val());
        if ($(elClassName).val() == 'internal') {
            $('.search-job-section').addClass('already-work-selected');
            $('select[name="contract_type"] option[value=Secondment]').prop('disabled', false);
            $('select[name="job-alert-contract_type"] option[value=Secondment]').prop('disabled', false);
        } else {
            $('.search-job-section').removeClass('already-work-selected');
            $('select[name="contract_type"] option[value=Secondment]').prop('disabled', 'disabled');
            $('select[name="job-alert-contract_type"] option[value=Secondment]').prop('disabled', 'disabled');
        }

        form_job_search.find('.already-work-component').find('input, select').val('').trigger('change');
        $('#jobs_alerts_form').find('.already-work-component').find('input, select').val('').trigger('change');

        var filteredArray = $('select[name="contract_type"]').val();
        $(filteredArray).each(function (index, value) {
            if (value === 'Secondment') {
                filteredArray.splice(index, 1);
            }
        });
        form_job_search.find('select[name="contract_type"]').val(filteredArray).trigger('change');

        let jobAlertfilteredArray = $('select[name="job-alert-contract_type"]').val();
        $(jobAlertfilteredArray).each(function (index, value) {
            if (value === 'Secondment') {
                jobAlertfilteredArray.splice(index, 1);
            }
        });
        $('#jobs_alerts_form')
            .find('select[name="job-alert-contract_type"]')
            .val(jobAlertfilteredArray)
            .trigger('change');

        buildSearchChips();
        loadJobs(false);
    }

    const stickyJobTypeSelect = document.querySelector('[name="job-type-select"]');

    $('[name="job-type-selector"]').on('change', function () {
        const checkedRadio = [...$(this)].find((radio) => radio.checked);
        if (checkedRadio) {
            stickyJobTypeSelect.value = checkedRadio.value;

            // Send jobfeed interest details to notification service
            notificationManager.sendTag('jobfeed_type', checkedRadio.value);
        }

        // Reset page on job type change
        $('[name="offset"]').val(0);

        checkFiltersAndLoadJobs('[name="job-type-select"]');
    });

    stickyJobTypeSelect?.addEventListener('change', function () {
        const selectedValue = stickyJobTypeSelect.value;
        $('[name="job-type-selector"]').each(function () {
            if ($(this).val() === selectedValue) {
                $(this).prop('checked', true);
            } else {
                $(this).prop('checked', false);
            }
        });

        // Send jobfeed interest details to notification service
        notificationManager.sendTag('jobfeed_type', selectedValue);
        // Reset page on job type change
        $('[name="offset"]').val(0);

        checkFiltersAndLoadJobs('[name="job-type-select"]');
    });

    buildSearchChips();

    setTimeout(() => {
        if ($('[name="jobfeed"]').val()) {
            loadJobs(false);
        }
    }, 400);

    // Use my position
    jQuery(document).on('click', '.my-location', function (e) {
        e.preventDefault();
        if (navigator.geolocation) {
            $(this).animate({ opacity: 0.5 }, 500);
            $(this).find('span span').text('Using my current location');
            navigator.geolocation.getCurrentPosition(setPosition);
        } else {
            alert('Geolocation is not supported by this browser.');
        }
    });

    jQuery(document).on('click', '.get-location-job-alert', function (e) {
        e.preventDefault();
        if (navigator.geolocation) {
            $(this).animate({ opacity: 0.5 }, 500);
            $(this).find('span span').text('Using my current location');
            navigator.geolocation.getCurrentPosition(setJobAlertPosition);
        } else {
            alert('Geolocation is not supported by this browser.');
        }
    });

    // Open job description page in new tab
    $(document).on('click', '.link-job-description', function (e) {
        e.preventDefault();
        if (!isInStandaloneMode()) {
            window.name = 'boots-jobs-parent';
            window.open(e.target.href);
        } else {
            window.location.href = e.target.href;
        }
    });

    // Open dropdown with checkboxes
    $(document).on('click', '.checkbox-enable', function (e) {
        $('.select2-container--open').addClass('custom-checkbox-select');
    });

    // Asynchronous return for user's position
    function setPosition(position) {
        jQuery('#lat').val(position.coords.latitude);
        jQuery('#lon').val(position.coords.longitude);

        // REVERSE ENGINEER THE ADDRESS FROM THE COORDINATES
        var latlng = { lat: parseFloat(position.coords.latitude), lng: parseFloat(position.coords.longitude) };
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({ location: latlng }, function (results, status) {
            if (status === 'OK') {
                if (results[0]) {
                    for (var i = 0; i < results.length; i++) {
                        if (results[i].types[0] == 'country') {
                            $('input[name=country]').val(results[i].formatted_address);
                            break;
                        }
                    }
                    for (var i = 0; i < results.length; i++) {
                        if (results[i].types[0] == 'locality') {
                            $('input[name=location]').val(results[0].formatted_address).trigger('keyup');

                            buildSearchChips();
                            handleLocationChange('#form-job-search');
                            loadJobs(false);

                            break;
                        } else {
                            $('input[name=location]').val(results[0].formatted_address).trigger('keyup');
                            buildSearchChips();
                            handleLocationChange('#form-job-search');
                            loadJobs(false);
                        }
                    }
                } else {
                    // window.alert('No results found');
                }
            } else {
                // window.alert('Geocoder failed due to: ' + status);
            }
        });
        // END ADDRESS REVERSING
    }

    function setJobAlertPosition(position) {
        jQuery('#job-alert-lat').val(position.coords.latitude);
        jQuery('#job-alert-lon').val(position.coords.longitude);
        const latlng = { lat: parseFloat(position.coords.latitude), lng: parseFloat(position.coords.longitude) };
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({ location: latlng }, function (results, status) {
            if (status === 'OK') {
                if (results[0]) {
                    for (let i = 0; i < results.length; i++) {
                        if (results[i].types[0] == 'country') {
                            $('input[name=job-alert-country]').val(results[i].formatted_address);
                            break;
                        }
                    }
                    for (let i = 0; i < results.length; i++) {
                        if (results[i].types[0] == 'locality') {
                            $('input[name=job-alert-location]').val(results[0].formatted_address).trigger('keyup');
                            break;
                        } else {
                            $('input[name=job-alert-location]').val(results[0].formatted_address).trigger('keyup');
                        }
                        populateInputValues();
                        buildChipsFromInputValuesForJobAlert();
                        handleLocationChange('#jobs_alerts_form');
                        disabledJobAlertFormSubmitButton();
                    }
                } else {
                    // window.alert('No results found');
                }
            } else {
                // window.alert('Geocoder failed due to: ' + status);
            }
        });
    }

    // Get query parameter value from URL
    function getParameterByName(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
})(jQuery);

document.addEventListener('DOMContentLoaded', function () {
    const stickyFilterBtn = document.querySelector('.sticky-filter-btn');
    const searchJobSection = document.querySelector('.search-job-section');
    const innerFormFilters = document.querySelector('.form-filters');

    const stickyFilterBtnHandler = () => {
        const isExpanded = searchJobSection.classList.toggle('show-filter-element');
        innerFormFilters.classList.add('search_active');
        stickyFilterBtn.setAttribute('aria-expanded', isExpanded);

        if (isExpanded) {
            jQuery('body').addClass('job-filters-open');
        } else {
            jQuery('body').removeClass('job-filters-open');
        }
    };

    stickyFilterBtn?.addEventListener('click', stickyFilterBtnHandler);

    // hide job filter in mobile by default
    function hideJobFilters() {
        if (jQuery(window).width() < 767) {
            jQuery('.search-job-section.exclude_moblie').removeClass('filter-enabled');
            jQuery('.form-filters').removeClass('search_active');
            jQuery('body').removeClass('job-filters-open');
        }
    }
    hideJobFilters();
});
document.addEventListener('DOMContentLoaded', function () {
    const radioButtons = document.querySelectorAll('input[name="job-type-selector"]');
    radioButtons.forEach(function (radioButton) {
        radioButton.addEventListener('change', function () {
            const selectedValue = document.querySelector('input[name="job-type-selector"]:checked').value;
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set('jobfeed', selectedValue);
            window.history.replaceState({ path: currentUrl.href }, '', currentUrl.href);
        });
    });
});